import styled from 'styled-components'
import { Heading } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Divider } from 'antd'
import { useTranslation } from 'react-i18next'

type ClockedInWidgetProps = {
  clockedIn: number
  total: number
}

const ClockedInWidget = ({ clockedIn, total }: ClockedInWidgetProps) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Heading level={3}>{t('CLOCKED_IN')}</Heading>
      <StyledDivider />
      <Content>
        <Heading level={1}>
          {clockedIn === 0 && total === 0
            ? t('NONE')
            : t('NUMBER_OUT_OF_TOTAL', { clockedIn, total })}
        </Heading>
        <LightText weight="medium">{t('TEAM_MEMBERS').toLowerCase()}</LightText>
      </Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${(props) => props.theme.color.neutral.color11};
  padding: 24px;
  border-radius: ${(props) => props.theme.properties.borderRadius.large};
  width: 100%;
  min-width: 0;
  height: 100%;
`
const StyledDivider = styled(Divider)`
  margin: 0;
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  margin: auto 0;
`

const LightText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color4};
`

export default ClockedInWidget
